import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { orderSummaryReducer, initialState } from './orderSummary.reducer';
import { OrderSummaryContextType } from './orderSummary.types';

const OrderSummaryContext = createContext<OrderSummaryContextType | undefined>(undefined);

export const OrderSummaryProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(orderSummaryReducer, initialState);

  return (
    <OrderSummaryContext.Provider value={{ state, dispatch }}>
      {children}
    </OrderSummaryContext.Provider>
  );
};

export const useOrderSummaryContext = () => {
  const context = useContext(OrderSummaryContext);
  if (context === undefined) {
    throw new Error('useOrderSummaryContext must be used within an OrderSummaryProvider');
  }
  return context;
};
